import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { chatsService } from './service';

export const chatQueries = {
  all: ['chats'] as const,
  messages: (chatId: string) => ['chats', chatId, 'messages'] as const,
};

export function useChatsQuery(search = '') {
  const trimmed = search.trim();

  return useQuery({
    queryKey: trimmed
      ? ([...chatQueries.all, 'search', trimmed] as const)
      : chatQueries.all,
    queryFn: () => chatsService.getAll(trimmed || undefined),
  });
}

export function useMessageSearchQuery(chatId: string | null, search: string) {
  const trimmed = search.trim();

  return useQuery({
    queryKey: ['chats', chatId ?? '', 'search', trimmed] as const,
    queryFn: () => chatsService.getMessages(chatId!, undefined, trimmed),
    enabled: Boolean(chatId) && trimmed.length >= 2,
  });
}

export function useMessagesQuery(chatId: string | null) {
  return useInfiniteQuery({
    queryKey: chatQueries.messages(chatId ?? ''),
    queryFn: ({ pageParam }) => chatsService.getMessages(chatId!, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled: !!chatId,
  });
}
